import { Typography } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import config from 'utilities/config';
import SwitchLocale from './views/switchLocale';

const useStyles = makeStyles(theme =>
  createStyles({
    item: {
      padding: '1em 1em 4em 1em',
    },
    footer: {
      backgroundColor: '#E3E3E8',
      display: 'block',
    },
    list: {
      listStyleType: 'none',
      margin: 0,
      padding: 0,
    },
    address: {},
    sectionDesktop: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'initial',
      },
    },
    sectionMobile: {
      display: 'flex',
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
  })
);

export interface BottomBarMobileProps {
  className: string;
}

const BottomBarMobile: React.FunctionComponent<
  BottomBarMobileProps
> = props => {
  return (
    <div className={props.className}>
      <div
        style={{
          backgroundColor: 'black',
          color: 'white',
          width: '100%',
          padding: '0.2em',
          position: 'fixed',
          bottom: '0%',
        }}
      >
        <div style={{ float: 'right' }}>
          <SwitchLocale compact={true} />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography variant="caption">
            Holstebro Auktioner ApS - Stationsvej 76 - 7500 Holstebro -{' '}
            <a
              style={{ color: 'white', cursor: 'pointer' }}
              href="tel:+4597401111"
            >
              (+45) 97 40 11 11
            </a>{' '}
            - mail@ho-auk.dk - CVR: 45729354
          </Typography>
          <a href="https://www.facebook.com/profile.php?id=61580028491190#">
            <img
              src="https://s.magecdn.com/social/24w/mw-facebook.png"
              style={{ margin: '5px 0 5px 30px' }}
              alt="Facebook"
            />
          </a>
          <a href="https://www.instagram.com/holstebro_auktioner/">
            <img
              src="https://s.magecdn.com/social/24w/mw-instagram.png"
              style={{ margin: '5px 0 5px 10px' }}
              alt="Instagram"
            />
          </a>
          <a href="https://www.linkedin.com/company/holstebro-auktioner/?viewAsMember=true">
            <img
              src="https://s.magecdn.com/social/24w/mw-linkedin.png"
              style={{ margin: '5px 0 5px 10px' }}
              alt="LinkedIn"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export interface BottomBarDesktopProps {
  className: string;
}

const BottomBarDesktop: React.FunctionComponent<
  BottomBarDesktopProps
> = props => {
  return (
    <div className={props.className}>
      <div
        style={{
          display: 'block',
          backgroundColor: 'black',
          color: 'white',
          width: '100%',
          padding: '0.2em',
          position: 'fixed',
          bottom: '0%',
        }}
      >
        <div style={{ float: 'right' }}>
          <SwitchLocale compact={false} />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography variant="caption">
            Holstebro Auktioner ApS - Stationsvej 76 - 7500 Holstebro -{' '}
            <a
              style={{ color: 'white', cursor: 'pointer' }}
              href="tel:+4597401111"
            >
              (+45) 97 40 11 11
            </a>{' '}
            - mail@ho-auk.dk - CVR: 45729354
          </Typography>
          <a href="https://www.facebook.com/profile.php?id=61580028491190#">
            <img
              src="https://s.magecdn.com/social/24w/mw-facebook.png"
              style={{ margin: '5px 0 5px 30px' }}
              alt="Facebook"
            />
          </a>
          <a href="https://www.instagram.com/holstebro_auktioner/">
            <img
              src="https://s.magecdn.com/social/24w/mw-instagram.png"
              style={{ margin: '5px 0 5px 10px' }}
              alt="Instagram"
            />
          </a>
          <a href="https://www.linkedin.com/company/holstebro-auktioner/?viewAsMember=true">
            <img
              src="https://s.magecdn.com/social/24w/mw-linkedin.png"
              style={{ margin: '5px 0 5px 10px' }}
              alt="LinkedIn"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

// export default BottomBarMobile;

export interface BottomBarProps {}

const BottomBar: React.FunctionComponent<BottomBarProps> = () => {
  const styling = useStyles({});
  const { t } = useTranslation();
  const email = config().company.email;

  if (config().features.newBottomBar) {
    return (
      <footer className={styling.footer}>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-evenly',
            alignItems: 'flex-start',
            borderTop: '1px solid #ccc',
          }}
        >
          <div className={styling.item}>
            <Typography variant="h6" gutterBottom>
              Auktionen
            </Typography>
            <ul className={styling.list}>
              <li>
                <Typography variant="body2">Køb på auktion</Typography>
              </li>
              <li>
                <Typography variant="body2">Salg på auktion</Typography>
              </li>
            </ul>
          </div>
          <div className={styling.item}>
            <Typography variant="h6" gutterBottom>
              Vi tilbyder
            </Typography>
            <ul className={styling.list}>
              <li>
                <Typography variant="body2">Vurderinger</Typography>
              </li>
              <li>
                <Typography variant="body2">Online auktioner</Typography>
              </li>
              <li>
                <Typography variant="body2">Fysiske auktioner</Typography>
              </li>
            </ul>
          </div>
          <div className={styling.item}>
            <address
              className={styling.address}
              style={{ fontStyle: 'normal' }}
            >
              <Typography variant="h6" gutterBottom>
                {t('bottombar.findus.title')}
              </Typography>
              <Typography variant="body2">{t('address.name')}</Typography>
              <Typography variant="body2">{t('address.road')}</Typography>
              <Typography variant="body2" gutterBottom>
                {t('address.postal')}
              </Typography>
              <Typography variant="body2">
                <a href="tel:+4597401111" style={{ color: 'inherit' }}>
                  (+45) 97 40 11 11
                </a>
              </Typography>
              <Typography variant="body2">
                <a href={`mailto:${email}`} style={{ color: 'inherit' }}>
                  {email}
                </a>
              </Typography>
              <div style={{ display: 'flex', gap: '10px', marginTop: '8px' }}>
                <a
                  href="https://www.facebook.com/profile.php?id=61580028491190"
                  aria-label="Facebook"
                >
                  <img
                    src="https://s.magecdn.com/social/24w/mw-facebook.png"
                    alt="Facebook"
                  />
                </a>
                <a
                  href="https://www.instagram.com/holstebro_auktioner/"
                  aria-label="Instagram"
                >
                  <img
                    src="https://s.magecdn.com/social/24w/mw-instagram.png"
                    alt="Instagram"
                  />
                </a>
                <a
                  href="https://www.linkedin.com/company/holstebro-auktioner/"
                  aria-label="LinkedIn"
                >
                  <img
                    src="https://s.magecdn.com/social/24w/mw-linkedin.png"
                    alt="LinkedIn"
                  />
                </a>
              </div>
            </address>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            borderTop: '1px solid #ccc',
            padding: '0.5em 1em',
          }}
        >
          <SwitchLocale compact={false} />
        </div>
      </footer>
    );
  } else {
    return (
      <Fragment>
        <BottomBarDesktop className={styling.sectionDesktop} />
        <BottomBarMobile className={styling.sectionMobile} />
      </Fragment>
    );
  }
};

export default BottomBar;
